import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tbId = 0,
    id = 0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.remove}/${tbId}`, {
        id,
    }, options);
    if (error) return { error, status };
    return content || {};
};
